(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-product-orbit-peek"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(section) {
    if (!section || section.dataset.orbitNativeReady === 'true') return;
    var rail = section.querySelector('[data-orbit-rail]');
    var cards = Array.from(section.querySelectorAll('[data-orbit-card]'));
    var backgrounds = Array.from(section.querySelectorAll('[data-orbit-scene]'));
    var dots = Array.from(section.querySelectorAll('[data-orbit-dot]'));
    var prev = section.querySelector('[data-orbit-prev]');
    var next = section.querySelector('[data-orbit-next]');
    var counter = section.querySelector('[data-orbit-current]');
    if (!rail || !cards.length) return;
    section.dataset.orbitNativeReady = 'true';
    var active = -1;
    var frame = 0;

    function nearestCard() {
      var bounds = rail.getBoundingClientRect();
      var center = bounds.left + bounds.width / 2;
      var best = Infinity, winner = 0;
      cards.forEach(function (card, i) {
        var rect = card.getBoundingClientRect();
        var distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < best) { best = distance; winner = i; }
      });
      return winner;
    }

    function update(index) {
      if (index < 0 || index >= cards.length || index === active) return;
      active = index;
      backgrounds.forEach(function (scene, i) {
        scene.classList.toggle('is-active', i === index);
      });
      cards.forEach(function (card, i) { card.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = String(index + 1).padStart(2, '0');
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === cards.length - 1;
    }

    function moveTo(index) {
      index = Math.min(cards.length - 1, Math.max(0, index));
      var viewport = rail.getBoundingClientRect();
      var card = cards[index].getBoundingClientRect();
      var offset = (card.left + card.width / 2) - (viewport.left + viewport.width / 2);
      rail.scrollTo({
        left: rail.scrollLeft + offset,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      update(index);
    }

    rail.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = 0; update(nearestCard()); });
    }, { passive: true });
    if ('onscrollend' in rail) {
      rail.addEventListener('scrollend', function () { update(nearestCard()); }, { passive: true });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { moveTo(i); });
    });
    if (prev) prev.addEventListener('click', function () { moveTo((active < 0 ? nearestCard() : active) - 1); });
    if (next) next.addEventListener('click', function () { moveTo((active < 0 ? nearestCard() : active) + 1); });

    cards.forEach(function (card, i) {
      card.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 750px) and (hover: hover)').matches) update(i);
      });
      card.addEventListener('focusin', function () {
        if (window.matchMedia('(min-width: 750px)').matches) update(i);
      });
    });

    section.addEventListener('shopify:block:select', function (event) {
      var card = event.target.closest('[data-orbit-card]');
      var i = cards.indexOf(card);
      if (i >= 0) moveTo(i);
    });
    update(nearestCard());
  }

  function initializeAll(root) {
    if (root.matches && root.matches('[data-skeez-orbit-scene]')) initialize(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-skeez-orbit-scene]').forEach(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-product-orbit-scene"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOrbit(section) {
    if (!section || section.dataset.orbitReady === 'true') return;
    var rail = section.querySelector('[data-orbit-rail]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-card]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-dot]'));
    var scenes = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-scene]'));
    if (!rail || !cards.length) return;
    section.dataset.orbitReady = 'true';

    var settledIndex = -1;
    var settleTimer = null;
    var backgroundFrame = 0;
    var railTouching = false;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var onMobile = window.matchMedia('(max-width: 749px)');

    function setActive(index) {
      if (index < 0 || index >= cards.length || settledIndex === index) return;
      settledIndex = index;
      scenes.forEach(function (scene, i) {
        scene.classList.toggle('is-active', i === index);
      });
      cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        var selected = i === index;
        dot.classList.toggle('is-active', selected);
        if (selected) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function closestCard() {
      var railBox = rail.getBoundingClientRect();
      var midpoint = railBox.left + railBox.width / 2;
      var winner = 0;
      var best = Infinity;
      cards.forEach(function (card, i) {
        var box = card.getBoundingClientRect();
        var distance = Math.abs(box.left + box.width / 2 - midpoint);
        if (distance < best) {
          best = distance;
          winner = i;
        }
      });
      return winner;
    }

    function blendScenesWithScroll() {
      backgroundFrame = 0;
      if (!onMobile.matches || scenes.length < 2) return;
      section.classList.add('is-scrubbing');
      // Position of each card centre relative to the carousel centre.
      // Each image's opacity changes continuously as that product moves into view.
      var railBox = rail.getBoundingClientRect();
      var midpoint = railBox.left + railBox.width / 2;
      var centres = cards.map(function (card) {
        var box = card.getBoundingClientRect();
        return box.left + box.width / 2 - midpoint;
      });
      var right = centres.findIndex(function (distance) { return distance >= 0; });
      var left = right - 1;
      if (right === -1) {
        left = centres.length - 1;
        right = left;
      } else if (left < 0) {
        left = right;
      }
      var progress = 0;
      if (left !== right) {
        var width = centres[right] - centres[left];
        progress = width > 0 ? Math.max(0, Math.min(1, -centres[left] / width)) : 0;
      }
      scenes.forEach(function (scene, index) {
        var opacity = index === left ? 1 - progress : index === right ? progress : 0;
        scene.style.opacity = opacity.toFixed(3);
      });
    }

    function queueBackgroundBlend() {
      if (!onMobile.matches || backgroundFrame) return;
      backgroundFrame = requestAnimationFrame(blendScenesWithScroll);
    }

    function commitSelection() {
      clearTimeout(settleTimer);
      settleTimer = null;
      if (railTouching) return;
      // Finish any pending paint before restoring the regular 1.15s
      // background transition for non-swipe changes.
      if (backgroundFrame) {
        cancelAnimationFrame(backgroundFrame);
        backgroundFrame = 0;
      }
      setActive(closestCard());
      scenes.forEach(function (scene) { scene.style.opacity = ''; });
      section.classList.remove('is-scrubbing');
    }

    function scheduleSelection() {
      clearTimeout(settleTimer);
      if (railTouching) return;
      settleTimer = setTimeout(commitSelection, 200);
    }

    rail.addEventListener('scroll', function () {
      queueBackgroundBlend();
      scheduleSelection();
    }, { passive: true });
    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') railTouching = true;
    }, { passive: true });
    function releaseRailTouch(event) {
      if (event.pointerType !== 'touch') return;
      railTouching = false;
      scheduleSelection();
    }
    rail.addEventListener('pointerup', releaseRailTouch, { passive: true });
    rail.addEventListener('pointercancel', releaseRailTouch, { passive: true });
    if ('onscrollend' in rail) {
      rail.addEventListener('scrollend', function () {
        if (!railTouching) commitSelection();
      });
    }

    function goTo(index) {
      if (index < 0 || index >= cards.length) return;
      var target = cards[index];
      var railBox = rail.getBoundingClientRect();
      var targetBox = target.getBoundingClientRect();
      var left = rail.scrollLeft + (targetBox.left - railBox.left) -
        (rail.clientWidth - targetBox.width) / 2;
      left = Math.max(0, Math.min(rail.scrollWidth - rail.clientWidth, left));
      rail.scrollTo({ left: left, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
      scheduleSelection();
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    cards.forEach(function (card, index) {
      card.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'mouse' &&
            window.matchMedia('(min-width: 750px) and (hover: hover)').matches) {
          setActive(index);
        }
      });
      card.addEventListener('focusin', function () {
        if (window.matchMedia('(min-width: 750px)').matches) setActive(index);
      });

      var stage = card.querySelector('[data-orbit-stage]');
      var media = card.querySelector('[data-orbit-media]');
      if (!stage || !media || card.querySelector('model-viewer')) return;
      // Product tilt intentionally disabled. Keep the product carousel and scene switching only.
      return;

      var pointerId = null;
      var startX = 0, startY = 0, startAt = 0;
      var latestX = 0, latestY = 0;
      var releaseTimer = null;
      function clamp(number, min, max) {
        return Math.max(min, Math.min(max, number));
      }
      function paint(rx, ry) {
        media.style.setProperty('--orbit-rx', rx.toFixed(2) + 'deg');
        media.style.setProperty('--orbit-ry', ry.toFixed(2) + 'deg');
        media.style.setProperty('--orbit-tx', (ry * .42).toFixed(2) + 'px');
        media.style.setProperty('--orbit-ty', (rx * -.3).toFixed(2) + 'px');
        media.style.setProperty('--orbit-scale', '1.055');
        media.style.setProperty('--orbit-shadow-x', (-ry * .9).toFixed(2) + 'px');
      }
      function paintFromPointer(event) {
        var box = stage.getBoundingClientRect();
        if (!box.width || !box.height) return;
        var x = clamp((event.clientX - box.left) / box.width - .5, -.5, .5);
        var y = clamp((event.clientY - box.top) / box.height - .5, -.5, .5);
        paint(y * -27, x * 46);
      }
      function reset() {
        stage.classList.remove('is-dragging');
        media.style.setProperty('--orbit-rx', '0deg');
        media.style.setProperty('--orbit-ry', '0deg');
        media.style.setProperty('--orbit-tx', '0px');
        media.style.setProperty('--orbit-ty', '0px');
        media.style.setProperty('--orbit-scale', '1');
        media.style.setProperty('--orbit-shadow-x', '0px');
      }
      function endPointer(event) {
        if (pointerId === null || (event && event.pointerId !== pointerId)) return;
        var endingId = pointerId;
        var dx = latestX - startX;
        var dy = latestY - startY;
        var elapsed = Date.now() - startAt;
        pointerId = null;
        // Clearing this before release prevents lostpointercapture from
        // overriding our swipe decision or ending tilt prematurely.
        if (stage.hasPointerCapture && stage.hasPointerCapture(endingId)) {
          stage.releasePointerCapture(endingId);
        }
        stage.classList.remove('is-dragging');
        clearTimeout(releaseTimer);
        releaseTimer = setTimeout(reset, 850);
        // A quick, long horizontal flick on the picture advances the carousel;
        // a slower drag simply tilts the image and returns it to center.
        if (event && event.pointerType === 'touch' &&
            Math.abs(dx) > 100 && Math.abs(dx) > Math.abs(dy) * 1.5 &&
            elapsed < 500 && window.matchMedia('(max-width: 749px)').matches) {
          goTo(index + (dx < 0 ? 1 : -1));
        }
      }
      stage.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (pointerId !== null) return;
        clearTimeout(releaseTimer);
        pointerId = event.pointerId;
        startX = latestX = event.clientX;
        startY = latestY = event.clientY;
        startAt = Date.now();
        stage.classList.add('is-dragging');
        try { stage.setPointerCapture(pointerId); } catch (error) {}
        if (event.pointerType === 'mouse') paintFromPointer(event);
      });
      stage.addEventListener('pointermove', function (event) {
        if (pointerId !== null) {
          if (event.pointerId !== pointerId) return;
          latestX = event.clientX;
          latestY = event.clientY;
          var dx = event.clientX - startX;
          var dy = event.clientY - startY;
          paint(clamp(dy * -.32, -15, 15), clamp(dx * .44, -24, 24));
          return;
        }
        if (event.pointerType === 'mouse' &&
            window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          clearTimeout(releaseTimer);
          stage.classList.add('is-dragging');
          paintFromPointer(event);
        }
      });
      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);
      stage.addEventListener('lostpointercapture', function () {
        if (pointerId !== null) {
          pointerId = null;
          clearTimeout(releaseTimer);
          releaseTimer = setTimeout(reset, 850);
        }
      });
      stage.addEventListener('pointerleave', function (event) {
        if (pointerId === null && event.pointerType === 'mouse') {
          clearTimeout(releaseTimer);
          stage.classList.remove('is-dragging');
          releaseTimer = setTimeout(reset, 450);
        }
      });
    });

    commitSelection();
    section.addEventListener('shopify:block:select', function (event) {
      var selected = event.target.closest('[data-orbit-card]');
      var index = cards.indexOf(selected);
      if (index < 0) return;
      if (window.matchMedia('(max-width: 749px)').matches) goTo(index);
      else setActive(index);
    });
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-skeez-orbit-scene]')) initOrbit(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-skeez-orbit-scene]').forEach(initOrbit);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-product-orbit"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initOrbit(section) {
    if (!section || section.dataset.orbitReady === 'true') return;

    var rail = section.querySelector('[data-orbit-rail]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-card]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-orbit-dot]'));
    if (!rail || !cards.length) return;
    section.dataset.orbitReady = 'true';

    var scrollFrame = 0;
    function setActive(index) {
      cards.forEach(function (card, i) { card.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    function activeFromScroll() {
      var railRect = rail.getBoundingClientRect();
      var center = railRect.left + railRect.width / 2;
      var closest = 0;
      var distance = Infinity;
      cards.forEach(function (card, index) {
        var rect = card.getBoundingClientRect();
        var delta = Math.abs((rect.left + rect.width / 2) - center);
        if (delta < distance) { distance = delta; closest = index; }
      });
      setActive(closest);
    }
    rail.addEventListener('scroll', function () {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(activeFromScroll);
    }, { passive: true });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        cards[index].scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          inline: 'center', block: 'nearest'
        });
        setActive(index);
      });
    });

    cards.forEach(function (card) {
      var stage = card.querySelector('[data-orbit-stage]');
      var media = card.querySelector('[data-orbit-media]');
      if (!stage || !media || card.querySelector('model-viewer')) return;

      var pointerId = null;
      var startX = 0;
      var startY = 0;
      var originX = 0;
      var originY = 0;
      var endTimer = null;

      function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
      }
      function paint(rx, ry) {
        media.style.setProperty('--orbit-rx', rx.toFixed(2) + 'deg');
        media.style.setProperty('--orbit-ry', ry.toFixed(2) + 'deg');
        media.style.setProperty('--orbit-tx', (ry * .42).toFixed(2) + 'px');
        media.style.setProperty('--orbit-ty', (rx * -.3).toFixed(2) + 'px');
        media.style.setProperty('--orbit-scale', '1.055');
        media.style.setProperty('--orbit-shadow-x', (-ry * .9).toFixed(2) + 'px');
      }
      function paintFromPointer(event) {
        var rect = stage.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = clamp((event.clientX - rect.left) / rect.width - .5, -.5, .5);
        var y = clamp((event.clientY - rect.top) / rect.height - .5, -.5, .5);
        paint(y * -27, x * 46);
      }
      function reset() {
        stage.classList.remove('is-dragging');
        media.style.setProperty('--orbit-rx', '0deg');
        media.style.setProperty('--orbit-ry', '0deg');
        media.style.setProperty('--orbit-tx', '0px');
        media.style.setProperty('--orbit-ty', '0px');
        media.style.setProperty('--orbit-scale', '1');
        media.style.setProperty('--orbit-shadow-x', '0px');
      }
      function endPointer(event) {
        if (pointerId === null || (event && event.pointerId !== pointerId)) return;
        if (stage.hasPointerCapture && stage.hasPointerCapture(pointerId)) {
          stage.releasePointerCapture(pointerId);
        }
        pointerId = null;
        clearTimeout(endTimer);
        stage.classList.remove('is-dragging');
        // Keep the last tilt visible briefly; previously it reset on finger lift.
        endTimer = setTimeout(reset, 850);
      }

      stage.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (pointerId !== null) return;
        clearTimeout(endTimer);
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        originX = 0;
        originY = 0;
        stage.classList.add('is-dragging');
        try { stage.setPointerCapture(event.pointerId); } catch (error) {}
        if (event.pointerType === 'mouse') paintFromPointer(event);
      });

      stage.addEventListener('pointermove', function (event) {
        if (pointerId !== null) {
          if (event.pointerId !== pointerId) return;
          // Gesture-based tilt works on iPhone even when a drag starts at image center.
          var dx = event.clientX - startX;
          var dy = event.clientY - startY;
          paint(clamp(dy * -.32 + originX, -15, 15), clamp(dx * .44 + originY, -24, 24));
          return;
        }
        if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          clearTimeout(endTimer);
          stage.classList.add('is-dragging');
          paintFromPointer(event);
        }
      });

      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);
      stage.addEventListener('lostpointercapture', function () {
        if (pointerId !== null) {
          pointerId = null;
          clearTimeout(endTimer);
          stage.classList.remove('is-dragging');
          endTimer = setTimeout(reset, 850);
        }
      });
      stage.addEventListener('pointerleave', function (event) {
        if (pointerId === null && event.pointerType === 'mouse') {
          clearTimeout(endTimer);
          stage.classList.remove('is-dragging');
          endTimer = setTimeout(reset, 450);
        }
      });
    });
    activeFromScroll();
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-skeez-orbit]')) initOrbit(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-skeez-orbit]').forEach(initOrbit);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-product-showcase-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(section){
    if(section.dataset.ssReady)return;
    var rail=section.querySelector('[data-ss-rail]');
    var cards=Array.from(section.querySelectorAll('[data-ss-card]'));
    var scenes=Array.from(section.querySelectorAll('[data-ss-scene]'));
    var dots=Array.from(section.querySelectorAll('[data-ss-dot]'));
    var prev=section.querySelector('[data-ss-prev]');
    var next=section.querySelector('[data-ss-next]');
    var current=section.querySelector('[data-ss-current]');
    if(!rail||!cards.length)return;
    section.dataset.ssReady='1';
    var active=-1, frame=0;
    function setActive(index){
      if(index<0||index>=cards.length||index===active)return;
      active=index;
      scenes.forEach(function(el,i){el.classList.toggle('is-active',i===index);});
      cards.forEach(function(el,i){el.classList.toggle('is-active',i===index);});
      dots.forEach(function(el,i){el.classList.toggle('is-active',i===index);if(i===index)el.setAttribute('aria-current','true');else el.removeAttribute('aria-current');});
      if(current)current.textContent=String(index+1).padStart(2,'0');
      if(prev)prev.disabled=index===0;
      if(next)next.disabled=index===cards.length-1;
    }
    function nearest(){
      var center=rail.getBoundingClientRect().left+rail.clientWidth/2;
      var index=0,dist=Infinity;
      cards.forEach(function(card,i){
        var box=card.getBoundingClientRect();
        var d=Math.abs(box.left+box.width/2-center);
        if(d<dist){dist=d;index=i;}
      });
      return index;
    }
    function moveTo(index){
      index=Math.max(0,Math.min(cards.length-1,index));
      var box=cards[index].getBoundingClientRect();
      var railBox=rail.getBoundingClientRect();
      var delta=box.left+box.width/2-(railBox.left+railBox.width/2);
      rail.scrollTo({left:rail.scrollLeft+delta,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      setActive(index);
    }
    rail.addEventListener('scroll',function(){
      if(frame)return;
      frame=requestAnimationFrame(function(){frame=0;setActive(nearest());});
    },{passive:true});
    dots.forEach(function(dot,i){dot.addEventListener('click',function(){moveTo(i);});});
    if(prev)prev.addEventListener('click',function(){moveTo((active<0?nearest():active)-1);});
    if(next)next.addEventListener('click',function(){moveTo((active<0?nearest():active)+1);});
    section.addEventListener('shopify:block:select',function(event){
      var card=event.target.closest('[data-ss-card]');
      var index=cards.indexOf(card);
      if(index>=0)moveTo(index);
    });
    setActive(nearest());
  }
  function initAll(root){
    if(root.matches&&root.matches('[data-skeez-showcase]'))init(root);
    root.querySelectorAll('[data-skeez-showcase]').forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);});
  else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-scratch-discount"]) return;
  try {
    
(function(){
  var roots=document.querySelectorAll("[data-skz-scratch]");
  roots.forEach(function(root){
    if(root.dataset.ready==="1")return;
    root.dataset.ready="1";

    var launcher=root.querySelector("[data-launch]");
    var launcherShell=root.querySelector("[data-launcher-shell]");
    var launcherDismiss=root.querySelector("[data-launcher-dismiss]");
    var dialog=root.querySelector("[data-dialog]");
    var card=root.querySelector("[data-card]");
    var canvas=root.querySelector("[data-canvas]");
    var stages=root.querySelectorAll("[data-stage]");
    var prizeNodes=root.querySelectorAll("[data-prize]");
    var rewardTitle=root.querySelector("[data-reward-title]");
    var codeNode=root.querySelector("[data-code]");
    var emailWrap=root.querySelector("[data-email-wrap]");
    var claimActions=root.querySelector("[data-claim-actions]");
    var emailToggle=root.querySelector("[data-email-toggle]");
    var emailBack=root.querySelector("[data-email-back]");
    var emailForm=root.querySelector("[data-email-wrap] form");
    var emailStatus=root.querySelector("[data-email-status]");
    var whatsapp=root.querySelector("[data-whatsapp]");
    var copy=root.querySelector("[data-copy]");
    var apply=root.querySelector("[data-apply]");
    var timerNode=root.querySelector("[data-timer]");
    var timerLabel=root.querySelector("[data-timer-label]");
    var timerWrap=root.querySelector("[data-timer-wrap]");
    var timerInterval=null;
    var timerMinutes=Math.max(1,Number(root.dataset.timerMinutes||15));
    var campaign=root.dataset.campaign||"launch";
    var key="skeez-scratch-v5:"+campaign;
    var state={};
    var oldHtmlOverflow="";
    var oldBodyOverflow="";
    var ctx;
    var active=false;
    var lastPoint=null;
    var revealed=false;
    var moveChecks=0;

    try{state=JSON.parse(localStorage.getItem(key)||"{}")}catch(e){}

    function save(){try{localStorage.setItem(key,JSON.stringify(state))}catch(e){}}

    var cooldownDays=Math.max(1,Number(root.dataset.cooldown||30));
    var cooldownMs=cooldownDays*24*60*60*1000;

    if(state.claimedAt&&!state.completedAt){
      state.completedAt=state.claimedAt;
      save();
    }

    if(state.completedAt&&Date.now()-Number(state.completedAt)>=cooldownMs){
      state={};
      save();
    }

    if(launcherShell&&state.completedAt){
      launcherShell.hidden=true;
    }

    function finishLauncher(reason){
      state.completedAt=Date.now();
      state.finishReason=reason||"done";
      save();
      if(launcherShell)launcherShell.hidden=true;
    }

    if(launcherDismiss){
      launcherDismiss.addEventListener("click",function(e){
        e.preventDefault();
        e.stopPropagation();
        finishLauncher("dismissed");
      });
    }

    var prizes=[
      {label:"5% OFF",code:root.dataset.code5||"SKEEZ5",weight:Number(root.dataset.weight5||0)},
      {label:"10% OFF",code:root.dataset.code10||"SKEEZ10",weight:Number(root.dataset.weight10||0)},
      {label:"15% OFF",code:root.dataset.code15||"SKEEZ15",weight:Number(root.dataset.weight15||0)},
      {label:"FREE SHIPPING",code:root.dataset.codeship||"SKEEZSHIP",weight:Number(root.dataset.weightship||0)}
    ];

    function pick(){
      var existing=prizes.find(function(p){return p.code===state.prizeCode});
      if(existing)return existing;
      var total=prizes.reduce(function(n,p){return n+p.weight},0);
      var r=Math.random()*(total||1);
      var selected=prizes[0];
      prizes.some(function(p){r-=p.weight;if(r<=0){selected=p;return true}return false});
      state.prizeCode=selected.code;state.prizeLabel=selected.label;save();
      return selected;
    }

    var prize=pick();

    function paintPrize(){
      prizeNodes.forEach(function(n){n.textContent=prize.label});
      rewardTitle.textContent=prize.label;
      codeNode.textContent=prize.code;
    }

    function stopTimer(){
      if(timerInterval){clearInterval(timerInterval);timerInterval=null}
    }

    function updateTimer(){
      if(!state.claimedAt||!timerNode||!timerWrap)return;
      var duration=timerMinutes*60*1000;
      var remaining=Math.max(0,duration-(Date.now()-Number(state.claimedAt)));
      var totalSeconds=Math.ceil(remaining/1000);
      var mins=Math.floor(totalSeconds/60);
      var secs=totalSeconds%60;
      timerNode.textContent=String(mins).padStart(2,"0")+":"+String(secs).padStart(2,"0");

      if(remaining<=0){
        stopTimer();
        if(!state.completedAt)finishLauncher("expired");
        root.classList.add("skz-expired");
        if(timerLabel)timerLabel.textContent="OFFER WINDOW ENDED";
        if(apply)apply.disabled=true;
        if(copy)copy.disabled=true;
      }else{
        root.classList.remove("skz-expired");
        if(timerLabel)timerLabel.textContent="USE YOUR CODE WITHIN";
        if(apply)apply.disabled=false;
        if(copy)copy.disabled=false;
      }
    }

    function startTimer(){
      stopTimer();
      updateTimer();
      if(state.claimedAt && (Date.now()-Number(state.claimedAt)) < timerMinutes*60*1000){
        timerInterval=setInterval(updateTimer,1000);
      }
    }

    function setStage(name,instant){
      var next=root.querySelector('[data-stage="'+name+'"]');
      var current=root.querySelector(".skz-stage:not([hidden])");
      if(!next||current===next)return;

      if(instant||!current){
        stages.forEach(function(s){
          s.hidden=s!==next;
          s.classList.remove("skz-stage-in","skz-stage-out");
        });
        if(name==="reward")startTimer();
        return;
      }

      next.hidden=false;
      next.classList.remove("skz-stage-out");
      next.classList.add("skz-stage-in");
      current.classList.remove("skz-stage-in");
      current.classList.add("skz-stage-out");

      setTimeout(function(){
        current.hidden=true;
        current.classList.remove("skz-stage-out");
        next.classList.remove("skz-stage-in");
        if(name==="reward")startTimer();
      },500);
    }

    function lockPage(){
      oldHtmlOverflow=document.documentElement.style.overflow;
      oldBodyOverflow=document.body.style.overflow;
      document.documentElement.style.overflow="hidden";
      document.body.style.overflow="hidden";
    }

    function unlockPage(){
      document.documentElement.style.overflow=oldHtmlOverflow;
      document.body.style.overflow=oldBodyOverflow;
    }

    function show(){
      paintPrize();
      revealed=Boolean(state.revealedAt);
      card.classList.toggle("is-revealed",revealed);

      if(state.claimedAt)setStage("reward",true);
      else if(state.revealedAt)setStage("claim",true);
      else setStage("scratch",true);

      if(!dialog.open){
        lockPage();
        dialog.showModal();
      }

      if(!state.revealedAt)requestAnimationFrame(drawIce);
    }

    function close(){
      stopTimer();
      dialog.close();
      unlockPage();
    }

    launcher.addEventListener("click",show);

    var scratchParam=new URLSearchParams(location.search).get("skeez_scratch");
    if(scratchParam==="reset"){
      try{localStorage.removeItem(key)}catch(e){}
      state={};
      save();
      if(launcherShell)launcherShell.hidden=false;
      prize=pick();
      revealed=false;
      card.classList.remove("is-revealed");
      setStage("scratch",true);
      show();
    }else if(scratchParam==="1"){
      show();
    }

    root.querySelectorAll("[data-close]").forEach(function(b){
      b.addEventListener("click",function(){
        if(b.hasAttribute("data-finish"))finishLauncher("finished");
        close();
      });
    });
    dialog.addEventListener("cancel",function(e){e.preventDefault();close()});
    dialog.addEventListener("close",unlockPage);

    function drawIce(){
      var rect=card.getBoundingClientRect();
      var dpr=Math.min(devicePixelRatio||1,2);
      canvas.width=Math.round(rect.width*dpr);
      canvas.height=Math.round(rect.height*dpr);
      ctx=canvas.getContext("2d",{willReadFrequently:true});

      var w=canvas.width;
      var h=canvas.height;
      var source=canvas.dataset.scratchImage;
      var img=new Image();
      img.crossOrigin="anonymous";

      function fallback(){
        var base=ctx.createLinearGradient(0,0,w,h);
        base.addColorStop(0,"#9fb7c4");
        base.addColorStop(.18,"#e8f0f4");
        base.addColorStop(.52,"#c7d7df");
        base.addColorStop(1,"#8fa9b7");
        ctx.fillStyle=base;
        ctx.fillRect(0,0,w,h);
      }

      function drawCover(){
        ctx.clearRect(0,0,w,h);
        ctx.drawImage(img,0,0,w,h);
      }

      img.onload=drawCover;
      img.onerror=fallback;
      img.src=source;
      if(img.complete&&img.naturalWidth){
        drawCover();
      }else{
        fallback();
      }
    }

    function point(e){
      var r=canvas.getBoundingClientRect();
      return{x:(e.clientX-r.left)*(canvas.width/r.width),y:(e.clientY-r.top)*(canvas.height/r.height)};
    }

    function scratch(p){
      if(!ctx||revealed)return;
      ctx.globalCompositeOperation="destination-out";
      ctx.lineCap="round";
      ctx.lineJoin="round";
      ctx.lineWidth=54*Math.min(devicePixelRatio||1,2);
      ctx.beginPath();
      if(lastPoint){ctx.moveTo(lastPoint.x,lastPoint.y);ctx.lineTo(p.x,p.y)}
      else{ctx.moveTo(p.x,p.y);ctx.lineTo(p.x+.1,p.y+.1)}
      ctx.stroke();
      lastPoint=p;
    }

    function percent(){
      if(!ctx)return 0;
      var data=ctx.getImageData(0,0,canvas.width,canvas.height).data;
      var clear=0,total=0;
      for(var i=3;i<data.length;i+=256){total++;if(data[i]<48)clear++}
      return total?clear/total*100:0;
    }

    function reveal(){
      if(revealed||state.revealedAt)return;
      revealed=true;active=false;
      card.classList.add("is-revealed");
      state.revealedAt=Date.now();save();
      setTimeout(function(){setStage("claim",false)},1000);
    }

    canvas.addEventListener("pointerdown",function(e){
      if(revealed)return;
      active=true;lastPoint=null;canvas.setPointerCapture(e.pointerId);scratch(point(e));e.preventDefault();
    });

    canvas.addEventListener("pointermove",function(e){
      if(!active||revealed)return;
      scratch(point(e));moveChecks++;
      if(moveChecks%7===0&&percent()>=Number(root.dataset.threshold||60))reveal();
      e.preventDefault();
    });

    function end(e){
      if(!active)return;
      active=false;lastPoint=null;
      if(canvas.hasPointerCapture(e.pointerId))canvas.releasePointerCapture(e.pointerId);
      if(!revealed&&percent()>=Number(root.dataset.threshold||60))reveal();
    }

    canvas.addEventListener("pointerup",end);
    canvas.addEventListener("pointercancel",end);
    card.addEventListener("keydown",function(e){if(e.key==="Enter"||e.key===" "){e.preventDefault();reveal()}});
    root.querySelector("[data-reveal]").addEventListener("click",reveal);

    function unlock(method){
      if(!state.claimedAt)state.claimedAt=Date.now();
      state.claimMethod=method;
      save();
      setStage("reward",false);
    }

    if(emailToggle&&emailWrap&&claimActions){
      emailToggle.addEventListener("click",function(){
        claimActions.hidden=true;
        emailWrap.hidden=false;
        var input=emailWrap.querySelector('input[type="email"]');
        if(input)setTimeout(function(){input.focus()},80);
      });
    }

    if(emailBack&&emailWrap&&claimActions){
      emailBack.addEventListener("click",function(){
        emailWrap.hidden=true;
        claimActions.hidden=false;
      });
    }

    async function submitEmailInline(){
      if(!emailForm)return;
      var button=emailForm.querySelector('button[type="submit"]');
      if(button&&button.disabled)return;
      if(button)button.disabled=true;
      if(emailStatus)emailStatus.textContent="Unlocking your reward…";

      try{
        var response=await fetch(emailForm.action,{
          method:"POST",
          body:new FormData(emailForm),
          credentials:"same-origin",
          redirect:"follow",
          headers:{"X-Requested-With":"XMLHttpRequest"}
        });
        if(!response.ok)throw new Error("subscribe failed");
        if(emailStatus)emailStatus.textContent="";
        unlock("email");
      }catch(err){
        if(emailStatus)emailStatus.textContent="We could not save that email. Please try again.";
        if(button)button.disabled=false;
      }
    }

    if(emailForm){
      root.addEventListener("submit",function(e){
        if(e.target!==emailForm)return;
        e.preventDefault();
        e.stopPropagation();
        if(typeof e.stopImmediatePropagation==="function")e.stopImmediatePropagation();
        submitEmailInline();
      },true);
    }

    if(whatsapp){
      whatsapp.addEventListener("click",function(e){
        if(whatsapp.getAttribute("aria-disabled")==="true"){e.preventDefault();return}
        unlock("whatsapp");
      });
    }

    copy.addEventListener("click",async function(){
      try{
        await navigator.clipboard.writeText(prize.code);
        copy.textContent="COPIED";
        setTimeout(function(){copy.textContent="COPY CODE"},1600);
      }catch(e){
        var range=document.createRange();range.selectNodeContents(codeNode);
        var sel=getSelection();sel.removeAllRanges();sel.addRange(range);
      }
    });

    apply.addEventListener("click",function(){
      finishLauncher("discount-applied");
      location.assign("/discount/"+encodeURIComponent(prize.code)+"?redirect="+encodeURIComponent("/collections/all"));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-shin-comparison"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (!section || section.dataset.skeezBaReady === 'true') return;
    var stage = section.querySelector('[data-ba-stage]');
    var input = section.querySelector('[data-ba-range]');
    if (!stage || !input) return;
    section.dataset.skeezBaReady = 'true';

    var activePointer = null;
    function position(value) {
      var next = Math.max(0, Math.min(100, Number(value)));
      stage.style.setProperty('--ba-position', next.toFixed(2) + '%');
      input.value = String(Math.round(next));
      input.setAttribute('aria-valuetext', Math.round(next) + ' percent');
    }
    function positionFromEvent(event) {
      var bounds = stage.getBoundingClientRect();
      if (!bounds.width) return;
      position((event.clientX - bounds.left) / bounds.width * 100);
    }
    stage.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      activePointer = event.pointerId;
      positionFromEvent(event);
      try { stage.setPointerCapture(activePointer); } catch (error) {}
    });
    stage.addEventListener('pointermove', function (event) {
      if (activePointer !== event.pointerId) return;
      positionFromEvent(event);
    });
    function release(event) {
      if (activePointer !== event.pointerId) return;
      activePointer = null;
      if (stage.hasPointerCapture && stage.hasPointerCapture(event.pointerId)) {
        stage.releasePointerCapture(event.pointerId);
      }
    }
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
    stage.addEventListener('lostpointercapture', function () { activePointer = null; });
    input.addEventListener('input', function () { position(input.value); });
    position(input.value);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-skeez-ba]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-skeez-ba]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeez-thermal-reveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (!section || section.dataset.thermalInitialized === 'true') return;
    section.dataset.thermalInitialized = 'true';
    var stage = section.querySelector('[data-thermal-stage]');
    if (!stage || section.dataset.imagesReady !== 'true') return;
    var status = section.querySelector('[data-thermal-status]');
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused = false, touching = false, idleTimer = null, releaseTimer = null, animationFrame = null;
    var t0 = 0;
    function point(x, y) {
      var rect = stage.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      stage.style.setProperty('--st-x', (Math.max(0, Math.min(100, (x - rect.left) / rect.width * 100))).toFixed(2) + '%');
      stage.style.setProperty('--st-y', (Math.max(0, Math.min(100, (y - rect.top) / rect.height * 100))).toFixed(2) + '%');
    }
    function show(event) {
      paused = true; clearTimeout(idleTimer); clearTimeout(releaseTimer);
      if (animationFrame) cancelAnimationFrame(animationFrame);
      point(event.clientX, event.clientY);
      stage.classList.add('is-revealing');
      if (status) status.textContent = 'HEAT REVEALED';
    }
    function reset() {
      stage.classList.remove('is-revealing');
      if (status) status.textContent = 'TOUCH TO REVEAL HEAT';
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { paused = false; t0 = 0; idle(); }, 2100);
    }
    function release() {
      touching = false;
      clearTimeout(releaseTimer);
      releaseTimer = setTimeout(reset, 80);
    }
    function idle(ts) {
      if (motion || paused || !stage.isConnected) return;
      if (!document.hidden && stage.getBoundingClientRect().width) {
        if (!t0) t0 = ts || performance.now();
        var elapsed = ((ts || performance.now()) - t0) % 6400;
        if (elapsed < 2750) {
          var a = elapsed / 2750;
          var rect = stage.getBoundingClientRect();
          point(rect.left + rect.width * (.24 + .52 * a), rect.top + rect.height * (.34 + .28 * Math.sin(a * Math.PI)));
          stage.classList.add('is-revealing');
        } else {
          stage.classList.remove('is-revealing');
        }
      }
      animationFrame = requestAnimationFrame(idle);
    }
    stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' || e.pointerType === 'pen') show(e); });
    stage.addEventListener('pointermove', function (e) { if (e.pointerType !== 'touch' || touching) show(e); });
    stage.addEventListener('pointerdown', function (e) { touching = true; show(e); });
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);
    stage.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') release(); });
    if (!motion) idleTimer = setTimeout(function () { idle(); }, 650);
  }
  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-skeez-thermal]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-skeez-thermal]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
